import { AddRounded, CheckCircleOutlineRounded, CloseRounded, Error, ErrorRounded } from '@mui/icons-material';
import { Alert, Box, Button, Grid, IconButton, Paper, Typography } from '@mui/material';
import axios from 'axios';
import _, { isEmpty, size } from 'lodash';
import React, { Component } from 'react';
import Currency from '../../common/Currency';
import Dialog from '../../common/Dialog';
import InputText from '../../common/Form';

// export const tmpPaygoList = [
//     {boxAssoId: "azaaa", paygoID: "PAYG1", clientName: "fefe"},
//     {boxAssoId: "4DASVBA", paygoID: "PAYG2", clientName: "toto"},
//     {boxAssoId: "FATGSV7", paygoID: "PAYG3", clientName: "tata"},
//     {boxAssoId: "ANSAO9O", paygoID: "PAYG4", clientName: "fifi"},
//     {boxAssoId: "GVAS6U", paygoID: "PAYG5", clientName: "lili"},
//     {boxAssoId: "568780HN", paygoID: "PAYG6", clientName: "bob"},
// ]


class ChantierFormPopUp extends Component {
    state = { 
        paygoID: "",
        // chantier_amount: this.props.spending_amount || "",
        list: size(this.props.list) > 0 ? this.props.list : [
            { paygoID: "", chantier_amount : "", boxAssoId: "", chantier_name: "", error: ""}
        ],
        nb: size(this.props.list) > 0 ? size(this.props.list) :  1
    }
    handleAddLine = () => {
        let list = [].concat(this.state.list)
        list.push({ paygoID: "", chantier_amount : "", boxAssoId: "", chantier_name: "", error: ""})
        this.setState({
            nb: this.state.nb + 1,
            list
        })
    }
    handleDeleteLine = (index) => {
        let list = [].concat(this.state.list)

        list = [
            ...list.slice(0,index),
            ...list.slice(index +1),
        ]
        
        this.setState({
            list: list,
            nb: this.state.nb - 1,
            
        })   
    }
    handleChange = (e, index) => {
        let list = [].concat(this.state.list)
        const { value, name } = e.target;
        
        const regexF = /^[-+]?[0-9]*\.?[0-9]+$/ // accept negatives
        // const regexF = /^(?[0-9]+([.][0-9]*)?|[.][0-9]+)$/
        const floatFields = [ "chantier_amount" ]
        
        if (!floatFields.includes(name) ){
            list[index][name] = value
            // list[index].boxAssoId = Object.keys(paygoList)[index]
            
        } else if (floatFields.includes(name) && (regexF.test(value) || value === "")){
            list[index][name] = parseFloat(value)
            // list[index].boxAssoId = Object.keys(paygoList)[index]
        }

        this.setState({
            list
        })
    }
    validate =  async() => {
        const { list } = this.state;
        let cpList = [].concat(list)
        let paygoList = []
        let clientList = {}
        let noError = true
        cpList.forEach( item => {
            paygoList.push(item.paygoID)
        })
        // send paygoList to 8000
        let res = await axios.post("/chantiers/resume/info", paygoList)
        // let res = await this.props.getClientInfo(paygoList)

        console.log('====================================');
        console.log({res});
        console.log('====================================');
        list.forEach( (client, idx) => {

            // const info = _.find(res.data.content.info, { paygoID: client.paygoID})
            // // const info = _.find(res, { paygoID: client.paygoID});
            if(!isEmpty(res.data.content.info) ){

                res.data.content.info.map(client => {
                    let clientObject = {}
                    client.map((field, index) => {
                        clientObject[res.data.content.name[index]] = field
                    })
                    clientList[clientObject.idBox] = clientObject
                })   

                if(isEmpty(clientList[client.paygoID])){
                    cpList[idx].error = "Paygo ID Introuvable"
                    noError = false
                } else{
                    cpList[idx].boxAssoId = clientList[client.paygoID].boxAssoId
                    cpList[idx].chantier_name = clientList[client.paygoID].clientName
                    cpList[idx].error = ""
                }
            } else {
                cpList[idx].error = "Paygo ID Introuvable"
                noError = false
            }
            
            console.log('====================================');
            console.log({clientList});
            console.log('====================================');
        

            if(!client.chantier_amount){
                cpList[idx].error2 = "Montant Invalide"
                noError = false
            } else{
                cpList[idx].error2 = ""
            }
        })

        if( (this.props.spending_amount - _.sumBy(this.state.list, 'chantier_amount')) < 0 ) {
            noError = false
            this.props.notif("error", "Montant insuffisant")
        }
        this.setState({ list: cpList})
        return noError

    }
        
    handleSubmit = async() => {
        // console.log(this.state.paygoID);
        let idList = []
        let displayList = []

        if (await this.validate() ){
            // get Infos (name and boxAssoId)
            this.state.list.forEach( item => {
                idList.push(item.boxAssoId)
                // displayList.push({value: item.boxAssoId, label: item.chantier_name})
                
            })
            console.log('====================================', this.validate());
            console.log('====================================');
            console.log({idList});
            console.log('====================================');
            this.props.setChantier( idList, this.state.list)
            // this.props.handleClose
        }
    }
    render() {
        console.log('====================================');
        console.log(this.state);
        console.log(_.sumBy(this.state.list, 'chantier_amount') );
        console.log('====================================');
        return (
            <Dialog
                title="Ajouter Chantier(s)"
                open={true}
                close={this.props.handleClose}
                submitAction={this.handleSubmit}
            >
                <Alert severity="warning">
                    Total: <Currency value={this.props.spending_amount} /> - Restant <Currency value={ this.props.spending_amount - (_.sumBy(this.state.list, 'chantier_amount')) } />
                </Alert>
                {this.state.list.map( (line, index) => 
                    <Box p={1}>
                        <Paper style={{position: "relative"}}>
                            <Grid container>
                                <Grid item xs={12} sm={8}>
                                    {size(this.state.list) > 1 &&
                                        <IconButton 
                                            color="error" 
                                            onClick={() => this.handleDeleteLine(index)} 
                                            style={{position: "absolute", left: "-35px", top: "15px"}} 
                                        >
                                            <CloseRounded />
                                        </IconButton>
                                    }
                                    <InputText
                                        required
                                        label="Paygo ID"
                                        name="paygoID"
                                        value={this.state.list[index].paygoID}
                                        onChange={ (e) => this.handleChange(e, index)}
                                        error={this.state.list[index].error}
                                        endAction={
                                            this.state.list[index].error &&
                                            <IconButton>
                                                <ErrorRounded color="error"/>
                                            </IconButton>
                                            // :
                                            // <IconButton>
                                            //     <CheckCircleOutlineRounded color="succes"/>
                                            // </IconButton>
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputText
                                        required
                                        label="Part"
                                        type="number"
                                        name="chantier_amount"
                                        value={this.state.list[index].chantier_amount}
                                        onChange={ (e) => this.handleChange(e, index)} // add regex validation
                                        error={this.state.list[index].error2}
                                    />
                                </Grid>
                                {this.state.list[index].chantier_name &&
                                    <Grid xs={12}>
                                        <Box p={1}>
                                            <Alert severity="info">
                                                <Typography variant="subtitle1">{this.state.list[index].chantier_name}</Typography>
                                            </Alert>
                                        </Box>
                                        {/* <Box p={2}></Box> */}
                                        {/* <Box p={1}><Typography variant="subtitle1">{this.state.list[index].chantier_name}</Typography></Box>
                                        <Box p={2}></Box> */}
                                    </Grid>
                                }
                            </Grid>
                        </Paper>
                    </Box>
                )}
                <Box p={1} style={{textAlign: 'center'}}>
                    <Button onClick={this.handleAddLine} startIcon={<AddRounded />}>Chantier</Button>
                </Box>
            </Dialog>
        );
    }
}

export default ChantierFormPopUp;